const SetupData = {
  files: {
    apiKey: 'VBKV2rL8uDSLzMBsnDGRus5ZTe9M75rDgZr8fMRmgzHsX9uapZDG4jjM94q7JrmQ',
  },

  activeTenantStatus: [
    { label: 'Status', value: '' },
    { label: 'Active', value: 'Active' },
    { label: 'Active - Early Move Out', value: 'Active - Early Move Out' },
    { label: 'Payment Due', value: 'Payment Due' },
    { label: 'Tenancy Expired', value: 'Tenancy Expired' },
    { label: 'Tenancy Expired - Early Move Out', value: 'Tenancy Expired - Early Move Out' },
    { label: 'Renew Tenancy', value: 'Renew Tenancy' },
    { label: 'Run Away', value: 'Run Away' },
    { label: 'Terminated', value: 'Terminated' }
  ],

  EtenanciesStatus: [
    { label: 'Status', value: '' },
    { label: 'New', value: 'New' },
    { label: 'Drafted', value: 'Drafted' },
    { label: 'Processing', value: 'Processing' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Cancel', value: 'Cancel' },
  ],

  managementUnitStatus: [
    { label: 'All', value: '' },
    { label: 'Management Unit', value: 'Management Unit' },
    { label: 'Non-Management Unit', value: 'Non-Management Unit' },
  ],

  unitGenderType: [
    { label: 'All', value: '' },
    { label: 'Male Unit', value: 'Male Unit' },
    { label: 'Female Unit', value: 'Female Unit' },
    { label: 'Mix Gender Unit', value: 'Mix Gender Unit' }
  ],

  managementLandlordStatus: [
    { label: 'All', value: '' },
    { label: 'Management', value: 'Management' },
    { label: 'Non-Management', value: 'Non-Management' },
  ],

  ownerStatus: [
    { label: 'Owned By Iroomz', value: 'Owned By Iroomz' },
    { label: 'Owned By Others', value: 'Owned By Others' },
  ],

  createdStatus: [
    { label: 'Created By Iroomz', value: 'Created By Iroomz' },
    { label: 'Created By Others', value: 'Created By Others' },
  ],

  landlordCreatedStatus: [
    { label: 'Created By Iroomz', value: 'Created By Iroomz' },
    { label: 'Created by Platform Subscriber', value: 'Created by Platform Subscriber' },
  ],

  userRegType: [
    { label: 'Individual', value: 'Individual' },
    { label: 'Company', value: 'Company' },
  ],

  tenancyPeriod: [
    { label: 'Select one', value: '' },
    { label: '6 Months', value: '6 Months' },
    { label: '1 Year', value: '1 Year' },
    { label: '2 Year', value: '2 Year' },
    { label: 'Other', value: 'Other' },
  ],
  nameTitle: [
    { label: 'Select one', value: '' },
    { label: 'Mr', value: 'Mr' },
    { label: 'Mrs', value: 'Mrs' },
    { label: 'Ms', value: 'Ms' },
  ],
  race: [
    { label: 'Select one', value: '' },
    { label: 'Malay', value: 'Malay' },
    { label: 'Chinese', value: 'Chinese' },
    { label: 'Indian', value: 'Indian' },
    { label: 'Other', value: 'Other' },
  ],
  gender: [
    { label: 'Select one', value: '' },
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
  ],
  tenancyRenewRequest: [
    { label: 'Pending Respond', value: 'Pending Respond' },
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' }
  ],
  checkoutReason: [
    { label: 'Select one', value: '' },
    { label: 'End Contract', value: 'End Contract' },
    { label: 'Change Room', value: 'Change Room' },
    { label: 'Others', value: 'Others' }
  ],
  maintenanceStatus: [
    { label: 'Status', value: '' },
    { label: 'New', value: 'New' },
    { label: 'In Progress', value: 'In Progress' },
    { label: 'Done', value: 'Done' }
  ],
  taskStatus: [
    { label: 'Pending', value: 'Pending' },
    { label: 'Done', value: 'Done' }
  ],
  depositAction: [
    { label: 'Refund Deposit', value: 'Refund Deposit' },
    { label: 'Forfeit Deposit', value: 'Forfeit Deposit' }
  ],

  outstandingAction: [
    { label: 'Pay With Refunds', value: 'Pay With Refunds' },
    { label: 'Mark as Bad Debt', value: 'Mark as Bad Debt' }
  ],

  // Note: update iroomzhost constant (XENDIT_CHANNEL_CODE) if modified
  bankName: [
    { label: 'Select Bank', value: '' },
    { label: 'Affin Bank Berhad', value: 'Affin Bank Berhad' },
    { label: 'Agrobank', value: 'Agrobank' },
    { label: 'Alliance Bank Malaysia Berhad', value: 'Alliance Bank Malaysia Berhad' },
    { label: 'Ambank (M) Berhad', value: 'Ambank (M) Berhad' },
    { label: 'Bank Islam Malaysia Berhad', value: 'Bank Islam Malaysia Berhad' },
    { label: 'Bank Muamalat (Malaysia) Berhad', value: 'Bank Muamalat (Malaysia) Berhad' },
    { label: 'Bank of America Malaysia Berhad', value: 'Bank of America Malaysia Berhad' },
    { label: 'Bank of China (Malaysia) Berhad', value: 'Bank of China (Malaysia) Berhad' },
    { label: 'Bank Rakyat', value: 'Bank Rakyat' },
    { label: 'Bank Simpanan Malaysia', value: 'Bank Simpanan Malaysia' },
    { label: 'CIMB Bank Berhad', value: 'CIMB Bank Berhad' },
    { label: 'Citibank Bank Berhad', value: 'Citibank Bank Berhad' },
    { label: 'GXBank', value: 'GXBank' },
    { label: 'Hong Leong Bank Berhad', value: 'Hong Leong Bank Berhad' },
    { label: 'HSBC Bank Malaysia Berhad', value: 'HSBC Bank Malaysia Berhad' },
    { label: 'Kuwait Finance House (Malaysia) Berhad', value: 'Kuwait Finance House (Malaysia) Berhad' },
    { label: 'Maybank Berhad', value: 'Maybank Berhad' },
    { label: 'MBSB Bank', value: 'MBSB Bank' },
    { label: 'OCBC Bank (Malaysia) Berhad', value: 'OCBC Bank (Malaysia) Berhad' },
    { label: 'Public Bank Berhad', value: 'Public Bank Berhad' },
    { label: 'RHB Bank Berhad', value: 'RHB Bank Berhad' },
    { label: 'Standard Chartered Bank (Malaysia) Berhad', value: 'Standard Chartered Bank (Malaysia) Berhad' },
    { label: 'United Oversea Bank (Malaysia) Berhad', value: 'United Oversea Bank (Malaysia) Berhad' },
  ],

  ewalletName: [
    { label: 'Select one', value: '' },
    { label: 'Boost', value: 'Boost' },
    { label: 'GrabPay', value: 'GrabPay' },
    { label: 'MAE', value: 'MAE' },
    { label: 'PayPal', value: 'PayPal' },
    { label: 'Setel', value: 'Setel' },
    { label: 'Shopee Pay', value: 'Shopee Pay' },
    { label: `Touch 'n Go`, value: `Touch 'n Go` },
  ],

  paymentMethod: [
    // {label: 'Debit/Credit Card', value: 'Debit/Credit Card'},
    // { label: 'FPX Online Banking', value: 'FPX Online Banking' }
    { label: 'Select one', value: '' },
    { label: 'Card', value: 'Card' },
    { label: 'Cash', value: 'Cash' },
    { label: 'Cheque', value: 'Cheque' },
    { label: 'Bank In / Manual Transfer', value: 'Bank In / Manual Transfer' },
    { label: 'Boost', value: 'Boost' },
    { label: 'FPX', value: 'FPX' },
    { label: 'GrabPay', value: 'GrabPay' },
    { label: 'MAE', value: 'MAE' },
    { label: 'MCash', value: 'MCash' },
    { label: 'ShopeePay', value: 'ShopeePay' },
    { label: `Touch 'n Go`, value: `Touch 'n Go` }
  ],

  filterPaymentMethod: [
    // {label: 'Debit/Credit Card', value: 'Debit/Credit Card'},
    // { label: 'FPX Online Banking', value: 'FPX Online Banking' }
    { label: 'Payment Method', value: '' },
    { label: 'Card', value: 'Card' },
    { label: 'Cash', value: 'Cash' },
    { label: 'Cheque', value: 'Cheque' },
    { label: 'Bank In / Manual Transfer', value: 'Bank In / Manual Transfer' },
    { label: 'E-Wallet', value: 'E-Wallet' },
    { label: 'FPX', value: 'FPX' },
  ],

  billType: [
    { label: 'Bill Type', value: '' },
    { label: 'Access Card Deposit', value: 'Access Card Deposit' },
    { label: 'Electricity', value: 'Electricity' },
    { label: 'Forfeit Deposit', value: 'Forfeit Deposit' },
    { label: 'Others', value: 'Others' },
    { label: 'Others - Deposit', value: 'Others - Deposit' },
    { label: 'Processing Fees', value: 'Processing Fees' },
    { label: 'Refund', value: 'Refund' },
    { label: 'Rental Deposit', value: 'Rental Deposit' },
    { label: 'Rental Fee', value: 'Rental Fee' },
    { label: 'Utility Deposit', value: 'Utility Deposit' },
  ],

  billStatus: [
    { label: 'Status', value: '' },
    { label: 'New', value: 'New' },
    { label: 'Issued', value: 'Issued' },
    { label: 'Issued - Payment In Progress', value: 'Issued - Payment In Progress' },
    { label: 'Issued - Payment Failed', value: 'Issued - Payment Failed' },
    { label: 'Paid', value: 'Paid' },
    { label: 'Bad Debt', value: 'Bad Debt' },
    { label: 'Cancelled', value: 'Cancelled' }
  ],

  billStatusLabel: [
    { label: 'Bad Debt', value: 'Bad Debt' },
    { label: 'Issued', value: 'Issued' },
    { label: 'Issued - Payment Failed', value: 'Issued - Payment Failed' },
    { label: 'Issued - Payment In Progress', value: 'Issued - Payment In Progress' },
    { label: 'New', value: 'New' },
    { label: 'Paid', value: 'Paid' },
    { label: 'Cancelled', value: 'Cancelled' }
  ],

  ownerBillStatus: [
    { label: 'Issued', value: 'Issued', isDisabled: true },
    { label: 'Issued - Payment In Progress', value: 'Issued - Payment In Progress', isDisabled: true },
    { label: 'Issued - Payment Failed', value: 'Issued - Payment Failed', isDisabled: true },
    { label: 'Paid', value: 'Paid' },
    { label: 'Voided', value: 'Voided' },
    { label: 'Cancelled', value: 'Cancelled' }
  ],

  meterStatus: [
    { label: 'Status', value: '' },
    { label: 'Connected - Power On', value: 3 },
    { label: 'Connected - Power Off', value: 4 },
    { label: 'Disconnected', value: 1 },
    { label: 'Offline', value: 2 },
    { label: 'Waiting for installation', value: 5 },
    { label: 'Waiting for removal', value: 6 },
  ],

  meterPurchaseStatus: [
    { label: 'Iroomz Smart Meter', value: 'Iroomz Smart Meter' },
    { label: 'Sold Smart Meter', value: 'Sold Smart Meter' },
  ],

  batteryLevel: [
    { label: 'Battery Level', value: '' },
    { label: 'Low Battery (<30%)', value: 'low' },
    { label: 'Sufficient Battery', value: 'high' },
  ],

  lockType: [
    { label: 'Type', value: '' },
    { label: 'Main Door', value: 'Main Door' },
    { label: 'Room Door', value: 'Room Door' },
  ],

  lockPurchaseStatus: [
    { label: 'Iroomz Smart Lock', value: 'Iroomz Smart Lock' },
    { label: 'Sold Smart Lock', value: 'Sold Smart Lock' },
  ],

  eKeyStatus: [
    { label: 'Normal', value: "110401" },
    { label: 'Pending', value: "110402" },
    { label: 'Freezed', value: "110405" },
    { label: 'Deleted', value: "110408" },
    { label: 'Reseted', value: "110410" },
  ],

  passcodeType: [
    { label: 'Select', value: '' },
    { label: 'One-time', value: 1 },
    { label: 'Permanent', value: 2 },
    { label: 'Period', value: 3 }, //refer to Period in TTlock documentation
    { label: 'Delete', value: 4 },
    { label: 'Weekend', value: 5 },
    { label: 'Daily', value: 6 },
    { label: 'Workday', value: 7 },
    { label: 'Every Monday', value: 8 },
    { label: 'Every Tuesday', value: 9 },
    { label: 'Every Wednesday', value: 10 },
    { label: 'Every Thursday', value: 11 },
    { label: 'Every Friday', value: 12 },
    { label: 'Every Saturday', value: 13 },
    { label: 'Every Sunday', value: 14 },
  ],

  fingerPrintType: [
    { label: 'Normal', value: 1 },
    { label: 'Cyclic', value: 4 }
  ],

  fingerPrintCyclic: [
    { label: 'Every Monday', value: 1 },
    { label: 'Every Tuesday', value: 2 },
    { label: 'Every Wednesday', value: 3 },
    { label: 'Every Thursday', value: 4 },
    { label: 'Every Friday', value: 5 },
    { label: 'Every Saturday', value: 6 },
    { label: 'Every Sunday', value: 7 },
  ],

  accessCardType: [
    { label: 'Normal-card', value: 1 },
    { label: 'Cyclic', value: 4 }
  ],

  receiptStatus: [
    { label: 'Status', value: '' },
    { label: 'Paid', value: 'Paid' },
    { label: 'Voided', value: 'Voided' },
  ],

  depositRefundStatus: [
    { label: 'Status', value: '' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Completed', value: 'Completed' },
  ],

  expensesType: [
    { label: 'Select One', value: '' },
    { label: 'Agent Fees', value: 'Agent Fees' },
    { label: 'Assessment', value: 'Assessment' },
    { label: 'Cleaning Fees', value: 'Cleaning Fees' },
    { label: 'Electric Charges', value: 'Electric Charges' },
    { label: 'Fire Insurance', value: 'Fire Insurance' },
    { label: 'Indah Water', value: 'Indah Water' },
    { label: 'Internet Charges', value: 'Internet Charges' },
    { label: 'Legal Fees', value: 'Legal Fees' },
    { label: 'Loan Interest', value: 'Loan Interest' },
    { label: 'Maintenance Fees', value: 'Maintenance Fees' },
    { label: 'Management Fees', value: 'Management Fees' },
    { label: 'Miscellaneous Expenses', value: 'Miscellaneous Expenses' },
    { label: 'Operator Commission', value: 'Operator Commission' },
    { label: 'Others', value: 'Others' },
    { label: 'Pest Control', value: 'Pest Control' },
    { label: 'Quit Rent', value: 'Quit Rent' },
    { label: 'Repairing Fees', value: 'Repairing Fees' },
    { label: 'Subscription Fees', value: 'Subscription Fees' },
    { label: 'Security Fees', value: 'Security Fees' },
    { label: 'Sinking Fund', value: 'Sinking Fund' },
    { label: 'Water Charges', value: 'Water Charges' }
  ],

  paymentStatus: [
    { label: 'Paid', value: 'Paid' },
    { label: 'Unpaid', value: 'Unpaid' },
  ],

  paymentTransactionStatus: [
    { label: 'Success', value: 'Success' },
    { label: 'Failed', value: 'Failed' },
    { label: "Pending - In Progress", value: "Pending - In Progress" },
  ],

  payoutTransactionStatus: [
    { label: 'Succeeded', value: 'SUCCEEDED' },
    { label: 'Accepted', value: 'ACCEPTED' },
    { label: 'Failed', value: 'FAILED' },
  ],

  transactionStatus: [
    { label: 'Success', value: 'Success' },
    { label: 'Failed', value: 'Failed' },
    { label: "Pending", value: "Pending" },
  ],

  splitBillType: [
    { label: 'All', value: '' },
    { label: 'Split Transaction', value: 'Split Transaction' },
    { label: "Non-split Transaction", value: "Non-split Transaction" },
  ],

  userRole: [
    { label: 'All', value: '' },
    { label: 'Admin', value: 'Admin' },
    { label: 'Landlord', value: 'Landlord' },
    { label: 'Office', value: 'Office' },
    { label: 'Operator', value: 'Operator' },
    { label: 'Owner', value: 'Owner' },
    { label: 'Tenant', value: 'Tenant' }
  ],

  dateFilter: [
    { label: 'Full Month', value: 'Full Month' },
    { label: 'First Half of Month (1st-15th monthly)', value: 'First Half of Month (1st-15th monthly)' },
    { label: 'Second Half of Month (16th-28th/29/th/30th/31st monthly)', value: 'Second Half of Month (16th-28th/29/th/30th/31st monthly)' },
    { label: 'By Year', value: 'By Year' },
  ],
  saleReportDateFilter: [
    { label: 'Daily', value: 'Daily' },
    { label: 'Monthly', value: 'Monthly' },
    { label: 'Yearly', value: 'Yearly' },
  ],
  saleReportSaleType: [
    { label: 'Chargeable Year Month', value: 'Chargeable Year Month' },
    { label: 'Paid Date/Created Date', value: 'Paid Date/Created Date' },
  ],
  meterReturnReason: [
    { label: 'Select One', value: '' },
    { label: 'Warranty', value: 'Warranty' },
    { label: 'Exchange of Meter', value: 'Exchange of Meter' },
    { label: 'Others', value: 'Others' }
  ],

  lockReturnReason: [
    { label: 'Select One', value: '' },
    { label: 'Warranty', value: 'Warranty' },
    { label: 'Exchange of Lock', value: 'Exchange of Lock' },
    { label: 'Others', value: 'Others' }
  ],

  gatewayReturnReason: [
    { label: 'Select One', value: '' },
    { label: 'Warranty', value: 'Warranty' },
    { label: 'Exchange of Gateway', value: 'Exchange of Gateway' },
    { label: 'Others', value: 'Others' }
  ],

  stockStatus: [
    { label: 'Select One', value: '' },
    { label: 'Stock In', value: 'Stock In' },
    { label: 'Stock Out', value: 'Stock Out' },
    { label: 'Replacement', value: 'Replacement' },
  ],

  storeInOptions: [
    { label: 'Select One', value: '' },
    { label: 'Store', value: 'Store' },
    { label: 'With Supplier', value: 'With Supplier' },
  ],

  storeOutOptions: [
    { label: 'Select One', value: '' },
    { label: 'Sold', value: 'Sold' },
    { label: 'Iroomz Use', value: 'Iroomz Use' },
  ],

  paymentVoucherStatus: [
    { label: 'Status', value: '' },
    { label: 'New', value: 'New' },
    { label: 'Approved', value: 'Approved' },
    { label: 'Cancelled', value: 'Cancelled' },
  ],

  payoutType: [
    { label: 'Unit Rental to Owner', value: 'Unit Rental to Owner' },
    { label: 'Management fees', value: 'Management fees' },
    { label: 'Electricity Bill', value: 'Electricity Bill' },
    { label: 'WiFi Bill', value: 'WiFi Bill' },
    { label: 'Cleaning Bill', value: 'Cleaning Bill' },
    { label: 'Water bill', value: 'Water bill' },
    { label: 'Cuckoo', value: 'Cuckoo' },
    { label: 'Indah water', value: 'Indah water' },
    { label: 'Agent Commission', value: 'Agent Commission' },
    { label: 'Operator Commission', value: 'Operator Commission' },
    { label: 'TA Fees', value: 'TA Fees' },
    { label: 'Claim', value: 'Claim' },
    { label: 'Aircond service', value: 'Aircond service' },
    { label: 'Pest control', value: 'Pest control' },
    { label: 'Other Expenses-Salary', value: 'Other Expenses-Salary' },
    { label: 'Other Expenses-PCB/SOCSO/EPF', value: 'Other Expenses-PCB/SOCSO/EPF' },
    { label: 'Other Expenses-DIGI Bill', value: 'Other Expenses-DIGI Bill' },
    { label: 'Other Expenses-I Roomz Domain Fees', value: 'Other Expenses-I Roomz Domain Fees' },
    { label: 'Other Expenses-Marketing Ads', value: 'Other Expenses-Marketing Ads' },
    { label: 'Other Expenses-Claim', value: 'Other Expenses-Claim' },
    { label: 'Other Expenses-CTOS Subscription', value: 'Other Expenses-CTOS Subscription' },
    { label: 'Other Expenses-Development fees', value: 'Other Expenses-Development fees' },
    { label: 'Product order', value: 'Product order' },
    { label: 'Deposit refund', value: 'Deposit refund' },
    { label: 'Stamping fee', value: 'Stamping fee' },
    { label: 'Operation cost', value: 'Operation cost' },
    { label: 'Others', value: 'Others' },
    { label: 'Late penalty/ Interests', value: 'Late penalty/ Interests' },
    { label: 'Marketing cost', value: 'Marketing cost' }
  ],

  paymentTerms: [
    { label: '50% Payment', value: '50% Payment' },
    { label: 'Full Payment', value: 'Full Payment' },
  ],

  roomStatus: [
    { label: 'Room Status', value: '' },
    { label: 'Vacant', value: 'Vacant' },
    { label: 'Booked', value: 'Booked' },
    { label: 'Occupied', value: 'Occupied' },
  ],

  bedsOptions: [
    "Studio",
    "1",
    "1+1",
    "1+2",
    "2",
    "2+1",
    "2+2",
    "3",
    "3+1",
    "3+2",
    "4",
    "4+1",
    "4+2",
    "5",
    "5+1",
    "5+2",
    "6",
    "6+",
    "6+1",
    "7",
    "7+",
    "7+1",
    "8",
    "8+",
    "8+1",
    "9",
    "9+",
    "9+1",
    "10",
    "10+",
    "10+1",
    "11",
    "11+",
    "11+1",
    "12",
    "12+",
    "12+1",
    "13",
    "13+",
    "13+1",
    "14",
    "14+",
    "14+1",
    "15",
    "15+1",
    "16",
    "16+",
    "17",
    "17+",
    "18",
    "18+",
    "19",
    "20 Above"
  ],

  bedType: [
    { label: 'Bed Type', value: '' },
    { label: 'Single', value: 'Single' },
    { label: 'Super Single', value: 'Super Single' },
    { label: 'King', value: 'King' },
    { label: 'Queen', value: 'Queen' },
  ],

  propertyListingCategory: [{
    categoryListing: "Residential",
    titles: [
      {
        "title": "Apartment/Flat",
        "showPropertyMaster": true,
        "type": ["Apartment", "Flat"]
      },
      {
        "title": "Condo/Serviced Residence",
        "showPropertyMaster": true,
        "type": ["Condominium", "Serviced Residence"]
      },
      {
        "title": "Terrace/Link/Townhouse",
        "showPropertyMaster": false,
        "type": [
          "1-sty Terrace/Link House",
          "1.5-sty Terrace/Link House",
          "2-sty Terrace/Link House",
          "2.5-sty Terrace/Link House",
          "3-sty Terrace/Link House",
          "3.5-sty Terrace/Link House",
          "4-sty Terrace/Link House",
          "4.5-sty Terrace/Link House",
          "2-sty Superlink House",
          "3-sty Superlink House",
          "Townhouse"
        ]
      },
      {
        "title": "Semi-D/Bungalow",
        "showPropertyMaster": false,
        "type": [
          "Cluster House",
          "Bungalow",
          "Bungalow Land",
          "Semi-detached House",
          "Villa",
          "3 Storey Semi-detached Homes"
        ]
      },
    ]
  },
  {
    categoryListing: "Commercial",
    titles: [
      {
        "title": "Shop/Office/Retail Space",
        "showPropertyMaster": false,
        "type": [
          "Office",
          "Shop",
          "Shop Office",
          "Retail Office",
          "Retail Space",
          "SOFO",
          "SOHO",
          "SOVO",
          "Commercial Bungalow",
          "Commercial Semi-D",
          "Designer Suites",
          "Business Center"
        ]
      },
      {
        "title": "Hotel/Resort",
        "showPropertyMaster": false,
        "type": ["Hotel/Resort"]
      },
      {
        "title": "Suites",
        "showPropertyMaster": false,
        "type": ["Suites"]
      },
      {
        "title": "Luxury Suites",
        "showPropertyMaster": false,
        "type": ["Luxury Suites"]
      },
    ]
  }],

  tenureStatus: [
    { label: 'Tenure', value: '' },
    { label: 'Freehold', value: 'Freehold' },
    { label: 'Lease Tenancy', value: 'Lease Tenancy' },
    { label: 'Leasehold', value: 'Leasehold' },
    { label: 'Malay Reserved Land', value: 'Malay Reserved Land' },
    { label: 'Unknown', value: 'Unknown' },
  ],

  furnishing: [
    { label: 'Furnishing', value: 'Furnishing' },
    { label: 'Fully Furnished', value: 'Fully Furnished' },
    { label: 'Partly Furnished', value: 'Partly Furnished' },
    { label: 'Unfurnished', value: 'Unfurnished' },
    { label: 'Unknown', value: 'Unknown' },
  ],

  exportOption: [
    { label: 'Export Option', value: '' },
    { label: 'By Unit', value: 'By Unit' },
    { label: 'By Smart Meter No/Smart Meter Name', value: 'By Smart Meter No/Smart Meter Name' },
    { label: "By Tenant's tenancy period", value: "By Tenant's tenancy period" },
    { label: "By Month", value: "By Month" },
  ],

  exportOwnerOption: [
    { label: 'Export Option', value: '' },
    { label: 'By Unit', value: 'By Unit' },
    { label: 'By Smart Meter No/Smart Meter Name', value: 'By Smart Meter No/Smart Meter Name' },
    { label: "By Month", value: "By Month" },
  ],

  stateOption: [
    { label: 'Johor', value: 'Johor' },
    { label: 'Kedah', value: 'Kedah' },
    { label: 'Kelantan', value: 'Kelantan' },
    { label: 'Melaka', value: 'Melaka' },
    { label: 'Negeri Sembilan', value: 'Negeri Sembilan' },
    { label: 'Pahang', value: 'Pahang' },
    { label: 'Pulau Pinang', value: 'Pulau Pinang' },
    { label: 'Perak', value: 'Perak' },
    { label: 'Perlis', value: 'Perlis' },
    { label: 'Selangor', value: 'Selangor' },
    { label: 'Terengganu', value: 'Terengganu' },
    { label: 'Sabah', value: 'Sabah' },
    { label: 'Sarawak', value: 'Sarawak' },
    { label: 'Wilayah Persekutuan Kuala Lumpur', value: 'Wilayah Persekutuan Kuala Lumpur' },
    { label: 'Wilayah Persekutuan Labuan', value: 'Wilayah Persekutuan Labuan' },
    { label: 'Wilayah Persekutuan Putrajaya', value: 'Wilayah Persekutuan Putrajaya' },
    { label: 'Others', value: 'Not Applicable' }
  ],
  
  classificationCode: [
    "009: e-Commerce - Self-billed e-Invoice to seller, logistics, etc.",
    "033: Self-billed - Betting and gaming",
    "034: Self-billed - Importation of goods",
    "035: Self-billed - Importation of services",
    "036: Self-billed - Others",
    "037: Self-billed - Monetary payment to agents, dealers or distributors",
    "045: Self-billed - Non-monetary payment to agents, dealers or distributors",
  ],

  eInvoiceStatus: [
    { label: 'Status', value: '' },
    { label: 'Not Submitted', value: 'Not Submitted' },
    { label: 'Processing', value: 'Processing' },
    { label: 'Valid', value: 'Valid' },
    { label: 'Invalid', value: 'Invalid' },
    { label: 'Cancelled', value: 'Cancelled' },
  ],

  portalSubscriptionPeriod: [
    { label: 'Portal Subscription Period', value: '' },
    { label: '12 months', value: '12' },
    { label: '24 months', value: '24' },
    { label: '36 months', value: '36' }
  ],

  receiverOptions: [
    {
      label: "Owner & Office Account",
      value: "root:owner-office"
    },
    {
      group: "Iroomz",
      options: [
        { label: "Landlord", value: "iroomz:Landlord" },
        { label: "Operator", value: "iroomz:Operator" },
        { label: "Tenant", value: "iroomz:Tenant" }
      ]
    },
    {
      group: "Owner",
      options: [
        { label: "Landlord", value: "owner:Landlord" },
        { label: "Operator", value: "owner:Operator" },
        { label: "Tenant", value: "owner:Tenant" }
      ]
    }
  ],

  gatewayStatus: [
    { label: 'Status', value: '' },
    { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' }
  ],

  gatawayPurchaseStatus: [
    { label: 'Iroomz Gateway', value: 'Iroomz Gateway' },
    { label: 'Sold Gateway', value: 'Sold Gateway' },
  ]

}

export default SetupData
